import { GetterTree, MutationTree } from 'vuex';
import { State } from '../types/categories';

export const state: () => State = () => ({
  category: null,
  tempData: null,
});

export const getters: GetterTree<State, Record<string, unknown>> = {
  getCategoryData: (state) => state.category,
  getTempData: (state) => state.tempData,
};

export const mutations: MutationTree<State> = {
  setTempData(state, value: State['tempData']) {
    state.tempData = {
      category: value?.category || null,
      headlines: value?.headlines || null,
    };
  },
  setCategoryData(state, value: State['category']) {
    state.category = value || null;
  },
  resetTempData(state) {
    state.tempData = null;
  },
};
